import React from "react";
import FieldTypesEnum from "../../../Enums/FieldTypesEnum";
import TabListTableCellWidthEnum from "../../../Enums/TabListTableCellWidthEnum";
import dateTimeHelper from "../../../Helpers/datetimeHelper";

export default class BambooHrApiLogItem
{
  constructor (item)
  {
    this.initialize(item);
  }

  async initialize (item)
  {
    this.BambooHrApiLogId = item.bambooHrApiLogId;
    this.Type = item.type;
    this.StartDate = item.startDate;
    this.EndDate = item.endDate;
    this.Result = item.result;
    this.Description = item.description;
  }

  static NameOfTheIdField ()
  {
    return "BambooHrApiLogId";
  }
  static nameOfTheItemDetailList ()
  {
    return "BambooHR Api Log";
  }

  static MoneyFields = [];

  static Currency ()
  {
    return "";
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary ()
  {
    return "";
  }

  static DateFields = [];

  static BoolFields = [];

  static FieldsToShowInListTable = [
    {
      tabName: "Info",
      tabLabel: "Info",
      icon: "fa-solid fa-info",
      data: [
        { name: "BambooHrApiLogId", label: "Log ID" },
        { name: "Type", label: "Type" },
        { name: "Result", label: "Result" },
        { name: (item) => dateTimeHelper.toYYYYsMMsDDsHHsMMsSS(item.StartDate), label: "StartDate" },
        { name: (item) => dateTimeHelper.toYYYYsMMsDDsHHsMMsSS(item.EndDate), label: "EndDate" },
        { name: BambooHrApiLogItem.GetDescriptionCellContent, label: "Description", width: TabListTableCellWidthEnum.TwoLines },
      ],
    },
  ];

  //Meaning of data field:
  //   if type is FieldTypesEnum.DataFieldWithDetails then it is the name of the ID field
  //   if type is FieldTypesEnum.PureDataField then it is the name of the field to show or it is a function
  //			and the field shows the result of this function
  //   if type is FieldTypesEnum.FunctionField then it is the function which will be called by clicking on the labeltext in the cell.
  static FieldsToShowInDataTable ()
  {
    return [
      { label: "Log ID", orderById: "Id", data: "BambooHrApiLogId", type: FieldTypesEnum.DataFieldWithDetails, minWidth: 50, className: "text-left" },
      { label: "Type", orderById: "Type", data: "Type", type: FieldTypesEnum.PureDataField, className: "text-left" },
      { label: "Start Date", orderById: "StartDate", data: (item) => dateTimeHelper.toYYYYsMMsDDsHHsMMsSS(item.StartDate), minWidth: 50, className: "text-left" },
      { label: "End Date", orderById: "EndDate", data: (item) => dateTimeHelper.toYYYYsMMsDDsHHsMMsSS(item.EndDate), minWidth: 50, className: "text-left" },
      { label: "Result", orderById: "Result", data: "Result", type: FieldTypesEnum.PureDataField, minWidth: 20, className: "text-left" },
    ];
  }

  static GetDescriptionCellContent (item)
  {
    return (
      <div
        className="text-left"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: item.Description }}
      />
    );
  }
}
